export const EVENTS = {
  PROFILE: {
    LOAD_DATA: 'profile.load_data',
    DATA_LOADED: 'profile.data_loaded',
    DATA_ERROR: 'profile.data_error'
  }
};
